import { FC } from "react";
import { FormikProps } from "formik"
import { TextArea } from "components/core";

interface IssueSummaryFormProps {
  issue: {
    code: string;
    issueBackground: string;
    issueDetails: string;
    action: string;
    expectation: string;
    attachments: string[];
    classification: string;
    priority: string;
    contactPerson: {
      fullName: string;
      email: string;
      phoneNumber: string;
    }
    clickupTicketId: string;
    createdBy: any;
    createdByType: string;
    meta: {
      ipAddress: string;
      userAgent: string;
      application: string;
    };
    status: string;
    stages: {
      user: string;
      userType: string;
      stage: string;
      notes?: string;
      escalatedTo?: string;
      timestamp: Date;
    }[];
    currentStage: {
      user: string;
      userType: string;
      stage: string;
      notes?: string;
      escalatedTo?: string;
      timestamp: Date;
    }
    createdAt: Date;
    updatedAt: Date;
  }
  form: FormikProps<any>
  isEscalation?: boolean
}

export const IssueSummaryForm: FC<IssueSummaryFormProps> = ({ issue, form, isEscalation = false }) => {

  const wordCount = form.values?.notes?.split(/\s+/)?.filter((word: string) => word.length > 0)?.length || 0
  const isWordCountValid = wordCount >= 150;

  return (
    <dl className="overflow-y-auto">
      <div className="sm:col-span-3 p-6 relative">
        <TextArea id="notes" label="Notes" {...form} rows={15} placeholder="eg. The issue proved to be very challenging because..." />
        {
          isEscalation && (
            <span className={`absolute bottom-1 right-6 text-xs ${isWordCountValid ? "" :" text-red-500"}`}>{wordCount}/150</span>
          )
        }
      </div>
    </dl>
  );
};

